module.exports = __webpack_public_path__ + "img/fangan2.367c6ab4.png";